import LeftNavigationMenuIcons from './LeftNavigationMenuIcons';

export default LeftNavigationMenuIcons;
